import React from 'react';

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {
  },
  setColorMode: (mode: 'light' | 'dark') => {
  },
});

export const useColorMode = () => React.useContext(ColorModeContext);
